"use strict";
/**
 * Win-probability shapes as the client sees them (`/win-prob/*`).
 *
 * Deliberately a narrow mirror of the server's types, not an import
 * of them: this page only renders, and the server is free to add fields
 * without the bundle growing a dependency on the model's internals.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWpHockeyState = void 0;
const isWpHockeyState = (s) => !!s && s.league === "nhl";
exports.isWpHockeyState = isWpHockeyState;
